import React, { useState } from "react";

export const UserContext =  React.createContext({});

const UserContextProvider = (props) => {
  const [userInfo, setUserInfo] = useState(props.userInfo);

  const replaceFacilityHandler = (facility) => {    
    // setUserInfo((prevUserInfo) => {
    //   let newUserInfo = {...prevUserInfo};
    //   newUserInfo.facility.orgUnitId = facility.orgUnitId; 
    //   newUserInfo.facility.displayName = facility.displayName; 
    //   // added by Mahmud
    //   newUserInfo.facility.netSIGL2StartDate = facility.netSIGL2StartDate;
    //   newUserInfo.facility.facilityLevel = facility.facilityLevel;
    //   newUserInfo.facility.netSIGL2InitComplete = facility.netSIGL2InitComplete;
    //   newUserInfo.facility.facilitySupplier = facility.facilitySupplier;
    //   newUserInfo.facility.isFirstReportGenerated = facility.isFirstReportGenerated;
    //   newUserInfo.facility.orgUnitLevel = facility.orgUnitLevel; 
    //   newUserInfo.ReadySyncCount = 0;
    //   return newUserInfo;
    // });
    return {};
  };

  const updateFacilityInitComplete = (facilityInitComplete) => {    
    // setUserInfo((prevUserInfo) => {
    //   let newUserInfo = {...prevUserInfo};
    //   newUserInfo.facility.netSIGL2InitComplete = facilityInitComplete;
    //   return newUserInfo;
    // });
    return {};
  };

  const updateFirstReportGenerateComplete = (facilityFirstReportgenerateComplete) => {    
    // setUserInfo((prevUserInfo) => {
    //   let newUserInfo = {...prevUserInfo};
    //   newUserInfo.facility.isFirstReportGenerated = facilityFirstReportgenerateComplete;
    //   return newUserInfo;
    // });
    return {};
  };

  const updateFacilityInitStartDate = (facilityInitStartDate) => {    
    // setUserInfo((prevUserInfo) => {
    //   let newUserInfo = {...prevUserInfo};
    //   newUserInfo.facility.netSIGL2StartDate = facilityInitStartDate;
    //   return newUserInfo;
    // });
    return {};
  };

  const updateReadySyncCount = (readySyncCount) => {    
    // setUserInfo((prevUserInfo) => {
    //   let newUserInfo = {...prevUserInfo};
    //   newUserInfo.ReadySyncCount = readySyncCount;
    //   return newUserInfo;
    // });

    return {};
  };

  const contextValue = {
    userInfo,
    replaceFacilityHandler: replaceFacilityHandler,
    updateFacilityInitComplete: updateFacilityInitComplete,
    updateFirstReportGenerateComplete: updateFirstReportGenerateComplete,
    updateFacilityInitStartDate: updateFacilityInitStartDate,
    updateReadySyncCount: updateReadySyncCount,
  };

  return (
    <UserContext.Provider value={contextValue}>
      {props.children}
    </UserContext.Provider>
  );
}

export default UserContextProvider;